module.exports = __webpack_public_path__ + "static/device_lockup_large-e2260d805a4bacd658a9c28c346bec9a.png";